import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
// The chat platforms Giga lives inside. These cycle in the home hero headline
// ("...your team in ___") to show Giga isn't locked to a single workspace.
// Order matters — Slack leads since it's the primary positioning.
const PLATFORMS = ['Slack', 'Teams'];
export function RotatingPlatform() {
  const reduce = useReducedMotion();
  const [index, setIndex] = useState(0);
  useEffect(() => {
    if (reduce) return;
    const id = setInterval(() => {
      setIndex(i => (i + 1) % PLATFORMS.length);
    }, 2200);
    return () => clearInterval(id);
  }, [reduce]);
  return (
    // Reserve the width of the WIDEST platform by stacking every option
    // invisibly in the same grid cell. This keeps the total sentence width
    // constant so the preceding words ("...your team in") never reflow or
    // re-center — only the platform word swaps. The word is left-anchored so
    // it always starts at the same x and any extra room sits to its right.
    <span className="relative inline-grid place-items-start align-baseline" data-id="element-759">
      <span className="invisible col-start-1 row-start-1" aria-hidden="true" data-id="element-760">
        {PLATFORMS.map(p => <span key={p} className="block" data-id="element-761">
            {p}
          </span>)}
      </span>
      <span className="col-start-1 row-start-1" data-id="element-762">
        <AnimatePresence mode="wait" initial={false} data-id="element-763">
          <motion.span key={PLATFORMS[index]} initial={reduce ? {
            opacity: 0
          } : {
            opacity: 0,
            y: '0.4em',
            filter: 'blur(4px)'
          }} animate={{
            opacity: 1,
            y: 0,
            filter: 'blur(0px)'
          }} exit={reduce ? {
            opacity: 0
          } : {
            opacity: 0,
            y: '-0.4em',
            filter: 'blur(4px)'
          }} transition={{
            duration: 0.4,
            ease: [0.16, 1, 0.3, 1]
          }} className="inline-block whitespace-nowrap" data-id="element-764">
            {PLATFORMS[index]}
          </motion.span>
        </AnimatePresence>
      </span>
    </span>
  );
}